// Function to send error message to Discord
const sendNotifyDiscord = async (message, prefix) => {
  // Define the endpoint URL
  const url = prefix + "support/react-notify";

  // Define the request body
  const body = {
    message: message,
  };

  const headers = {
    "Content-Type": "application/json",
  };

  try {
    // Make the POST request
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(body),
    });

    // Check if the request was successful
    if (response.ok) {
    } else {
      console.error(`Failed to send error: ${response.status}`);
    }
  } catch (error) {
    // Handle exceptions
    console.error(`Exception occurred: ${error.message}`);
  }
};

export default sendNotifyDiscord;
